import { useMemo } from 'react'
import { APIS } from '@constants/apis'
import useExportJob, {
  EXPORT_JOB_STATUS,
  getExportPollDelay
} from './useExportJob'

export const TIME_EXPORT_JOB_STATUS = EXPORT_JOB_STATUS

export const getTimeExportPollDelay = getExportPollDelay

export const getTimeExportStorageKey = ({ scope, companyCode }) =>
  `time-export-job:${scope}:${companyCode || 'current'}`

const useTimeExportJob = ({
  scope,
  companyCode,
  onCompleted,
  onFailed,
  onTrackingError
}) => {
  const storageKey = useMemo(
    () => getTimeExportStorageKey({ scope, companyCode }),
    [scope, companyCode]
  )
  const statusPayload = useMemo(
    () => (companyCode ? { companyCode } : {}),
    [companyCode]
  )

  return useExportJob({
    statusApi: APIS.TIME.GET_EXPORT_STATUS,
    storageKey,
    statusPayload,
    onCompleted,
    onFailed,
    onTrackingError
  })
}

export default useTimeExportJob
